import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { cmmsTheme } from "@setup/theme/cmms-theme";

type Props = {};

export const SearchFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";
	const [localValue, setLocalValue] = useState(search);

	// Update local value when URL param changes (e.g., from reset)
	useEffect(() => {
		setLocalValue(search);
	}, [search]);

	// Debounce search param update
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			if (localValue !== search) {
				const newSearchParams = new URLSearchParams(window.location.search);
				if (localValue === "") {
					newSearchParams.delete("search");
				} else {
					newSearchParams.set("search", localValue);
				}
				setSearchParams(newSearchParams, { replace: true });
			}
		}, 400);

		return () => clearTimeout(timeoutId);
	}, [localValue, search, setSearchParams]);

	const handleFilter = (e: any) => {
		setLocalValue(e.target.value);
	};

	return (
		<Box position="relative">
			<TextField
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				label="Search"
				variant="outlined"
				margin="dense"
				value={localValue}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
				slotProps={{
					// Label always on the border, like every other filter field
					inputLabel: { shrink: true },
					input: {
						style: {
							paddingRight: 45,
							height: cmmsTheme.dimensions.standardInput,
							marginTop: cmmsTheme.spacing.inputOffset,
						},
					},
				}}
			/>
			<i
				className="fa fa-search"
				style={{
					position: "absolute",
					right: 17,
					top: 20,
					cursor: "pointer",
				}}
			/>
		</Box>
	);
};
